import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as types from "../../../constants/actionTypes";
import ErrorPage from "../../common/ErrorPage";
import _ from 'lodash';
import { withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import { formatDoctorName } from "../../../helpers/formatting";
import * as d from "../../../reducers/domainReducer";
import AmbulatorySurvey from "./AmbulatorySurvey";
import ConfirmationModal from "../../common/ConfirmationModal";
import NotAuthorized from "../../common/NotAuthorized";
import TwilioVideo from "../VideoVisitV2";
import { CONSUMER } from '../VideoVisitV2/constants';
import VideoVisitToolTip from "./VideoVisitToolTip";
import { endCall } from '../VideoVisitV2/utils';
import AmbulatoryCareRoomStatus from "./AmbulatoryCareRoomStatus";
import Video from 'twilio-video';
import enhanceMessage from '../VideoVisitV2/components/enhanceMessage';
import BrowserErrorMessages from './BrowserErrorMessages';
import Preflight from '../VideoVisitV2/components/Preflight';
import { logRTCDiagnostics } from "../VideoVisitV2/utils/RTCDiagnostics";
import GuestVideoVisitStatus from "./GuestVideoVisitStatus";
import ipRangeCheck from 'ip-range-check';
import Dashboard from "../../dashboard/Dashboard";
import Appointment from "../../estimates/appointment";
import Spinner from '../../common/spinner';

const TOKEN_STATUS = { WAITING: "WAITING", APPROVED: "TOKEN_GENERATED", DENIED: "GUEST NOT ALLOWED", KICKED: "KICKED", CANCELED: "CANCELED" };
var _csnId = null;
var _patientInternalId = null;
var _appointmentDetails = null;

class AmbulatoryCareVideoVisit extends React.Component {
    constructor(props) {
        super(props);
        const csnId = props.match.params.csnId;
        if (csnId && !isNaN(csnId)) {
            _csnId = csnId;
        }
        else {
            const searchParams = location.search ? queryString.parse(location.search)
                : location.searchParms ? queryString.parse(location.searchParms) : null;
            _csnId = searchParams && searchParams['csnid'];
            _patientInternalId = searchParams && searchParams['patientinternalid'];
            if (_patientInternalId) {
                _patientInternalId = _patientInternalId.replace(/\+|\s/g, '');
            }
        }
        this.canEnableVisit = false;
        this.state = {
            videoVisitError: false,
            csnIdOfAppointment: _csnId,//this.props.match.params.csnId,       // CSN ID of the visit, from the route.
            hasAudioIn: false,
            hasAudioOut: false,
            hasVideoIn: false,
            hardwareScanned: false,
            enableLaunchButton: this.canEnableVisit,
            showAmbulatorySurvey: false,
            isTestVideo: this.props.match.params.csnId ? this.props.match.params.csnId.toLowerCase() === 'test' : false,
            timeToStartVideo: null,
            errorCode: null,
            errorMsg: "We were unable to begin the video visit.",
            isFetchingTwilioToken: false,
            isPermissionToDevices: false,
            isFetchingSharedLinkToken: false,
            mediaError: null,
            twilioUserName: null, //using this for survey.
            twilioDiagnosticsSettings: null,
            isConnecting: false,
            rtcDiagnosticsComplete: false,
            preflightComplete: false,
            roomTokenAssigned: false,
            showApprovalWaiting: false,
            showApprovalDenied: false,
            showUserKicked: false,
            isCurrentSystemRestricted: false
        };

        this.hasVideoVisitLanched = false;

        this.getAudioVideoStatus = this.getAudioVideoStatus.bind(this);

        this.testVideoVisit = this.testVideoVisit.bind(this);
        this.tryAgainClick = this.tryAgainClick.bind(this);
        this.checkCurrentSystemRestricted = this.checkCurrentSystemRestricted.bind(this);

        this.onTwilioEndCall = this.onTwilioEndCall.bind(this);
        this.enableAudioAndVideo = this.enableAudioAndVideo.bind(this);

        const { os, osVersion } = Tools.getOSInfo();
        let needIOSUpgrade = props.needIOSUpgrade;
        if (needIOSUpgrade === undefined) {
            const isiOS = os && os === "iOS" && Tools.isMobile() && osVersion && osVersion[0];
            needIOSUpgrade = isiOS && osVersion[0] == 15 && osVersion[1] && osVersion[1] == 1;
        }
        this.isSupportedBrowser = Video.isSupported && !needIOSUpgrade;
        if (this.isSupportedBrowser) {
            this.getAudioVideoStatus();
        }
        else {
            const env = {
                browser: window.serverData.data.browser,
                browserVersion: window.serverData.data.browserVersion,
                os,
                osVersion
            }
            logUI("MBHWeb.UI.VideoVisit.Twilio.NotSupported", new Date(), Tools.getURLPath(), env);
        }

        this.currentBrowserName = Tools.browserDetection();
        this.android = Tools.isAndroid();
        this.ios = Tools.isIos();
        const me = this;
        // set a timer to enable the launch button when it's time for the visit to start, and disable it when the visit has expired.
        var timer = setInterval(() => {
            this.canEnableVisit = me.isTimeToStart();
            let current = me.state.enableLaunchButton;

            // only update state when a change occurs...
            if (this.canEnableVisit !== current) {
                me.setState({ enableLaunchButton: this.canEnableVisit });
            }
        }, 5000);
        this.videoErrorMsg = "";
        this.isSDCVisit = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisit.ComponentDidMount", new Date(), Tools.getURLPath());
        const { roomId, jwttoken, isFromNonLogin, sharedLinkCode } = this.props;
        this.canEnableVisit = this.isTimeToStart();
        const { enableLaunchButton, isCurrentSystemRestricted } = this.state;
        if (enableLaunchButton !== this.canEnableVisit) {
            this.setState({ enableLaunchButton: this.canEnableVisit });
        }

        const checkIfCurrentSystemRestricted = this.checkCurrentSystemRestricted();
        if (!isCurrentSystemRestricted) {
            this.setState({ isCurrentSystemRestricted: checkIfCurrentSystemRestricted });
        }

        if (isFromNonLogin && sharedLinkCode && !jwttoken) {  // if jwttoken not found in SharedLink
            logUI("MBHWeb.UI.VideoVisit.Twilio.ShareLinkCode", new Date(), Tools.getURLPath(), { shareLinkCode: sharedLinkCode });
            const url = Tools.buildUrl(window.serverData.data.portalAPIURL, `/api/v2/video/ConsumerShareLinkToken?sharedLinkCode=${sharedLinkCode}`);
            const params = {
                headers: {
                    "accept": "application/json",
                    "content-type": "application/json"
                },
                method: "GET"
            };
            this.setState({ isFetchingSharedLinkToken: true });
            this.shareLinkTokenCallTimer = setInterval(() => {
                this.fetchSharedLinkRoomDetails(url, params);
            }, window.serverData.data.guestLinkStatusIntervalSeconds * 1000);
        }
    }

    componentWillUnmount() {
        window.twilioRoom = null;
        logUI("MBHWeb.UI.VideoVisit.ComponentWillUnmount", new Date(), Tools.getURLPath());
    }

    checkCurrentSystemRestricted() {
        let isRestricted = false;
        const { serverData } = this.props;
        const myIp = serverData && serverData.ipAddress ? serverData.ipAddress : null;
        const cidrArr = serverData && serverData.twilioIPRangesToRestrict ? serverData.twilioIPRangesToRestrict : null
        const cidrArrValues = cidrArr ? cidrArr.split(',') : [];
        try {
            if (myIp && cidrArr) {
                isRestricted = ipRangeCheck(myIp, cidrArrValues);
                if (isRestricted) {
                    logUI("MBHWeb.UI.VideoVisit.CurrentSystemIP.Restricted", new Date(), Tools.getURLPath(), { myIp, RestrictedCIDRValues: cidrArr });
                }
            }
        } catch (e) {
            console.log(e);
        }
        return isRestricted;
    }

    fetchSharedLinkRoomDetails = (url, params) => {
        logUI("MBHWeb.UI.VideoVisit.FetchJWTToken", new Date(), Tools.getURLPath(), { isFromSharedLink: true });
        fetch(url, params)
            .then(resp => {
                return resp.json();
            })
            .then(resp => {
                const { jwtToken = null, status = null, room = "", error, hasError, username = null, twilioConnectSettings = {}, twilioDiagnosticsSettings = {} } = resp || {};
                if (hasError && error) {
                    if (this.shareLinkTokenCallTimer)
                        clearInterval(this.shareLinkTokenCallTimer);
                    this.setState({ isFetchingSharedLinkToken: false });
                    const { error: errorMessage } = error;
                    if (errorMessage.toUpperCase().indexOf(TOKEN_STATUS.DENIED) > -1) {
                        this.setState({ showApprovalDenied: true });
                    }
                    else if (errorMessage.toUpperCase().indexOf(TOKEN_STATUS.KICKED) > -1) {
                        this.setState({ showUserKicked: true });
                    }
                    else
                        throw errorMessage;
                }
                else if (jwtToken && room && (status === null || (status && status.toUpperCase() === TOKEN_STATUS.APPROVED))) { //We are bypassing if status is null becuase API code is not out there.
                    if (status) {
                        logUI("MBHWeb.UI.VideoVisit.FetchJWTToken.RequestApproved", new Date(), Tools.getURLPath());
                    }
                    if (this.shareLinkTokenCallTimer)
                        clearInterval(this.shareLinkTokenCallTimer);

                    if (!twilioConnectSettings) {
                        logUI("MBHWeb.UI.VideoVisit.DynamicSettings.NotFound", new Date(), Tools.getURLPath());
                    } else {
                        logUI("MBHWeb.UI.VideoVisit.DynamicSettings.Found", new Date(), Tools.getURLPath(), twilioConnectSettings);
                    }
                    const { enablePreflightTest = false, preflightDurationInSeconds = 5 } = twilioDiagnosticsSettings || {};
                    const { enableRTCDiagnostics, enableTwilioPreflightTest } = window.serverData.data;
                    this.setState({ showApprovalWaiting: false, roomConnectionData: { token: jwtToken, roomName: room, twilioUserName: username, twilioConnectSettings, twilioDiagnosticsSettings } }, () => {
                        if (!enablePreflightTest || !enableTwilioPreflightTest)
                            this.onPreflightComplete();
                        else {
                            this.setState({ showPreflight: true, preflightTokenInfo: { token: jwtToken, roomName: room, twilioUserName: username, testDuration: preflightDurationInSeconds } });
                        }
                    });
                    if (!enableRTCDiagnostics) {
                        this.onRTCDiagnosticsComplete();
                    }
                    else {
                        logRTCDiagnostics(twilioDiagnosticsSettings, room, username, this.onRTCDiagnosticsComplete);
                    }
                    logUI("MBHWeb.UI.VideoVisit.Start.Success", new Date(), Tools.getURLPath());
                }
                else if (!jwtToken && status && status.toUpperCase() === TOKEN_STATUS.WAITING) {
                    this.setState({ showApprovalWaiting: true, twilioUserName: username });
                    logUI("MBHWeb.UI.VideoVisit.FetchJWTToken.RequestWaiting", new Date(), Tools.getURLPath());
                } else {
                    logUI("MBHWeb.UI.VideoVisit.FetchJWTToken.NoStatus", new Date(), Tools.getURLPath());
                    if (this.shareLinkTokenCallTimer) {
                        clearInterval(this.shareLinkTokenCallTimer);
                    }
                    throw "We're sorry, we're not able to load your video visit.";
                }
            })
            .catch(err => {
                console.log("video visit error", err);
                logUI("MBHWeb.UI.VideoVisit.Start.Error", new Date(), Tools.getURLPath(), { error: err });
                this.setState({ roomError: err && typeof err === 'string' ? err : "We're sorry, we're not able to load your video visit.", showSharedLinkTryAgain: err && err.toUpperCase().indexOf(TOKEN_STATUS.CANCELED) > -1 ? false : true });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        const { userIsSwitching, history } = this.props;
        if (prevProps && prevProps.userIsSwitching && !userIsSwitching) {
            if (history)
                //debugger;
                history.push("/");
        }
    }

    componentWillUnmount() {
        if (endCall) {
            endCall();
        }
        if (this.shareLinkTokenCallTimer)
            clearInterval(this.shareLinkTokenCallTimer);
    }

    callbackOnLeave = () => {
        if (window.userToSwitch) {
            this.props.switchToMyChartUser(window.userToSwitch, window.userToSwitch.index);
        }
    }

    onTwilioEndCall(room) {
        const userName = room && room.localParticipant && room.localParticipant.identity ? room.localParticipant.identity : "";
        this.setState((prevState) => ({
            showAmbulatorySurvey: true,
            twilioUserName: userName ? userName : prevState.twilioUserName
        }));
        logUI("MBHWeb.UI.VideoVisit.LeftRoom", new Date(), Tools.getURLPath(), JSON.stringify({ "VideoType": "Twilio" }));
    }

    getAudioVideoStatus() {
        let hasAudioIn = false;
        let hasAudioOut = false;
        let hasVideoIn = false;

        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices()
                .then(info => {
                    for (var i = 0; i < info.length; i++) {
                        const device = info[i];
                        const deviceType = device.kind;

                        if (deviceType.toLowerCase() === "audioinput") {
                            hasAudioIn = true;
                        }

                        if (deviceType.toLowerCase() === "audiooutput") {
                            hasAudioOut = true;
                        }

                        if (deviceType.toLowerCase() === "videoinput") {
                            hasVideoIn = true;
                        }
                    }

                    //Audio out validation is not supported by safari.
                    if ((Tools.isSafari() || this.ios || this.currentBrowserName === 'Firefox') && !hasAudioOut) {
                        logUI("MBHWeb.UI.VideoVisit.HardwareScan.AudioOut.Skip", new Date(), Tools.getURLPath());
                        hasAudioOut = true;
                    }

                    // some loser needs to get in the visit even though he has no camera  :)
                    if (window.location.search && window.location.search.toLocaleLowerCase().indexOf("hwbypass") > 0) {
                        hasAudioIn = true;
                        hasAudioOut = true;
                        hasVideoIn = true;
                    }

                    //Try to enable audio/video device.
                    if (hasAudioIn || hasVideoIn) {
                        this.enableAudioAndVideo(hasAudioIn, hasVideoIn);
                    } else {
                        //To Avoid race condition and let twilio throws the error when connect.
                        this.setState({
                            isPermissionToDevices: true,
                            mediaError: null
                        });
                    }

                    this.setState({ hasAudioIn: hasAudioIn, hasAudioOut: hasAudioOut, hasVideoIn: hasVideoIn, hardwareScanned: true }, () => {
                        logUI("MBHWeb.UI.VideoVisit.HardwareScan.Completed", new Date(), Tools.getURLPath());
                        if (this.state.isTestVideo) {
                            this.testVideoVisit();
                        }
                    });
                })
                .catch(err => {
                    this.setState({ hardwareScanned: false });
                    console.log("Error detecting client audio/video hardware");
                    logUI("MBHWeb.UI.VideoVisit.HardwareScan.Error", new Date(), Tools.getURLPath());
                });
        }
    }

    //Try to enable audio and video
    enableAudioAndVideo(audio, video) {
        try {
            const constraint = {}
            if (audio)
                constraint.audio = true;
            if (video)
                constraint.video = true;
            //Forcing Front Facing camera
            if (this.android) {
                constraint["video"] = { facingMode: { exact: "user" } };
            }
            const me = this;


            // Older browsers might not implement mediaDevices at all, so we set an empty object first
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }
            // Some browsers partially implement mediaDevices.
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                    }
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                }
            }
            //TODO Depends on the Failure do we need to show message or skip. 
            navigator.mediaDevices.getUserMedia(constraint)
                .then(function (stream) {
                    if (!stream) { return; }
                    console.log(stream);

                    const tracks = stream.getTracks();
                    if (!tracks) { return; }
                    tracks.forEach(track => track.stop());

                    me.setState({
                        isPermissionToDevices: true,
                        mediaError: null
                    });
                })
                .catch(function (err) {
                    console.log(err.name + ": " + err.message);
                    const { message, name } = err || {};
                    logUI("MBHWeb.UI.VideoVisit.EnableAudioOrVideo.Error", new Date(), Tools.getURLPath(),
                        {
                            "code": name ? name : "",
                            "message": message ? message : ""
                        });
                    //NotAllowedError - "User has denied accessed"
                    //PermissionDismissedError                 
                    me.setState({
                        isPermissionToDevices: true,
                        mediaError: err
                    });
                }
                );
        } catch (e) {
            console.log(e);
            logUI("MBHWeb.UI.VideoVisit.EnableAudioOrVideo.Exception", new Date(), Tools.getURLPath(), { error: e });
        }
    }

    // returns true if we're within five minutes of the visit's scheduled start time.
    isTimeToStart() {
        const appointmentDetails = _appointmentDetails;// this.props.videoVisits;
        var ret = false;
        const { videoVisitEnabledMinutesBeforeStart, videoVisitEnabledMinutesAfterStart,
            SDCVisitEnabledMinutesBeforeStart, SDCVisitEnabledMinutesAfterStart } = this.props;

        const minutesBefore = this.isSDCVisit ? SDCVisitEnabledMinutesBeforeStart : videoVisitEnabledMinutesBeforeStart;
        const minutesAfter = this.isSDCVisit ? SDCVisitEnabledMinutesAfterStart : videoVisitEnabledMinutesAfterStart;

        if (appointmentDetails && appointmentDetails.appointmentDateTime) {
            const now = Tools.toJSDate(new Date());
            const startTime = Tools.toJSDate(appointmentDetails.appointmentDateTime);
            const timeBefore = Tools.toJSDate(startTime);
            timeBefore.setMinutes(timeBefore.getMinutes() - minutesBefore);
            const timeAfter = Tools.toJSDate(startTime);
            timeAfter.setMinutes(timeAfter.getMinutes() + minutesAfter);
            //Check if appt is for today.
            const isApptToday = now.getFullYear() === startTime.getFullYear() && now.getMonth() === startTime.getMonth()
                && now.getDate() === startTime.getDate() ? true : false;
            if (now >= timeBefore && isApptToday) {
                ret = true;
            }
        }

        return ret;
    }

    // returns true if the next appointment is today
    isToday() {
        const appointmentDetails = _appointmentDetails;// this.props.videoVisits;
        var ret = false;

        if (appointmentDetails && appointmentDetails.appointmentDateTime) {
            const now = new Date();
            const startTime = new Date(appointmentDetails.appointmentDateTime);

            if (now.getFullYear() === startTime.getFullYear() && now.getMonth() === startTime.getMonth() && now.getDate() === startTime.getDate()) {
                ret = true;
            }
        }

        return ret;
    }

    daysUntilAppointment(appt) {
        const now = new Date();
        const then = new Date(appt && appt.appointmentDateTime);
        var difference = then.getTime() - now.getTime();
        difference = difference / (1000 * 3600 * 24);

        return Math.round(difference);
    }

    startVideoVisit() {
        if (this.isTimeToStart()) {
            const visit = _appointmentDetails;//this.props.videoVisits; //this.props.videoVisitDetails;
            var csnId = visit.csnIdOfAppointment;
            var patientName = visit.patientName;
            var physicianName = visit.physicianName ? formatDoctorName(visit.physicianName) : "MyBSWHealth Video Visit";
            var patientId = visit.patientIDs.find((v, i) => { return v.idType === "Internal" || v.idType === "External"; });
            var physicianId = visit.providerIDs.find((v, i) => { return v.idType === "Internal" || v.idType === "External"; });

            if (patientId) {
                patientId = patientId.id.trim();
            }

            if (physicianId) {
                physicianId = physicianId.id.trim();
            }
            if (this.videoErrorMsg === "" && this.state.mediaError === null) {
                this.doVideoVisit(patientName, patientId, physicianId, csnId, physicianName);
            } else {
                this.hasVideoVisitLanched = true;
                logUI("MBHWeb.UI.VideoVisit.LoadError", new Date(), Tools.getURLPath());
                this.setState({ timeToStartVideo: true });
            }
        }
        else {
            this.setState({ timeToStartVideo: false });
        }
    }

    // same as startVideoVisit, but only used if the user is in the Video_POC role, and only uses the test MYBSWHEALTHLOBBY chat room.
    testVideoVisit() {
        console.log("TST Start video visit");
        var isPOC = this.props.roles ? this.props.roles.toLowerCase().indexOf("video_poc") >= 0 : false;
        if (isPOC === true && this.props.currentUser && this.props.currentUser.externalId) {
            if (this.videoErrorMsg === "" && this.state.mediaError === null) {
                logUI("MBHWeb.UI.VideoVisit.Test.Start", new Date(), Tools.getURLPath());
                const patientName = this.props.currentUser.displayName ? this.props.currentUser.displayName : this.props.userName;
                this.doVideoVisit(patientName, this.props.currentUser.externalId, "123456", "MYBSWHEALTHLOBBY", "MyBSWHealth Lobby");
            }
        } else {
            logUI("MBHWeb.UI.VideoVisit.Test.AccessIssue", new Date(), Tools.getURLPath());
            this.setState({ videoVisitError: true });
        }
    }

    fetchTwilioRoomDetails = (url, params, isFromSharedLink = false) => {
        logUI("MBHWeb.UI.VideoVisit.FetchJWTToken", new Date(), Tools.getURLPath(), { isFromSharedLink: isFromSharedLink });
        fetch(url, params)
            .then(resp => {
                return resp.json();
            })
            .then(resp => {
                if (!resp || !resp.jwtToken || resp.hasError) {
                    logUI("MBHWeb.UI.VideoVisit.FetchJWTToken.Error", new Date(), Tools.getURLPath(), { error: resp ? resp : "", isFromSharedLink: isFromSharedLink });
                    throw (isFromSharedLink ? resp && resp.error && resp.error.error ? resp.error.error : "" : "JWT Token is null");
                }
                if (resp && !resp.roomIsAvailable) {
                    if (resp.errorCode) {
                        this.setState({
                            errorCode: parseInt(resp.errorCode)
                        });
                        logUI("MBHWeb.UI.VideoVisit.Start.RoomNotAvailable", new Date(), Tools.getURLPath(), { errorCode: resp.errorCode });
                        return;
                    }
                }
                var token = resp.jwtToken;
                var roomName = resp.room;
                let twilioUserName = resp && resp.username ? resp.username : null;
                const twilioConnectSettings = resp && resp.twilioConnectSettings ? resp.twilioConnectSettings : null;
                const twilioDiagnosticsSettings = resp && resp.twilioDiagnosticsSettings ? resp.twilioDiagnosticsSettings : null;
                if (!twilioConnectSettings) {
                    logUI("MBHWeb.UI.VideoVisit.DynamicSettings.NotFound", new Date(), Tools.getURLPath());
                } else {
                    logUI("MBHWeb.UI.VideoVisit.DynamicSettings.Found", new Date(), Tools.getURLPath(), twilioConnectSettings);
                }
                const { enableRTCDiagnostics, enableTwilioPreflightTest } = window.serverData.data;
                const { enablePreflightTest = false, preflightDurationInSeconds = 5 } = twilioDiagnosticsSettings || {};
                this.setState({ roomConnectionData: { token, roomName, twilioUserName, twilioConnectSettings, twilioDiagnosticsSettings } }, () => {
                    if (!enablePreflightTest || !enableTwilioPreflightTest) {
                        this.onPreflightComplete();
                    } else {
                        this.setState({ showPreflight: true, preflightTokenInfo: { token, roomName, twilioUserName, testDuration: preflightDurationInSeconds } });
                    }
                });
                if (!enableRTCDiagnostics) {
                    this.onRTCDiagnosticsComplete();
                }
                else {
                    logRTCDiagnostics(twilioDiagnosticsSettings, roomName, twilioUserName, this.onRTCDiagnosticsComplete);
                }
                logUI("MBHWeb.UI.VideoVisit.Start.Success", new Date(), Tools.getURLPath());
            })
            .catch(err => {
                console.log("video visit error", err);
                logUI("MBHWeb.UI.VideoVisit.Start.Error", new Date(), Tools.getURLPath(), { error: err });
                if (!isFromSharedLink) {
                    this.setState({ videoVisitError: true });
                }
                else
                    this.setState({ roomError: err && typeof err === 'string' ? err : "We're sorry, we're not able to load your video visit.", showSharedLinkTryAgain: true });
            });
    }

    doVideoVisit(patientName, patientId, physicianId, csnId, physicianName) {
        const url = Tools.buildUrl(window.serverData.data.portalAPIURL, "/api/v2/video/ConsumerToken");
        this.hasVideoVisitLanched = true;
        logUI("MBHWeb.UI.VideoVisit.Start", new Date(), Tools.getURLPath());
        const body = {
            participantId: patientId,
            participantIdType: "External",
            participantRole: "Patient",
            participantName: patientName,
            csnId: csnId,
            epicExternalProviderId: physicianId
        };

        const params = {
            headers: {
                "accept": "application/json",
                "content-type": "application/json",
                "Authorization": `bearer ${this.props.token}`
            },
            body: JSON.stringify(body),
            method: "POST"
        };
        this.setState({ isFetchingTwilioToken: true, roomTokenAssigned: false, preflightComplete: false, rtcDiagnosticsComplete: false });
        this.fetchTwilioRoomDetails(url, params);
    }

    getVideoErrorMsg(videoDetailsError, hardwareError, timeToStartVideo, errorCode, isSDC) {
        let errorMsg = ''; let hardwareErrorMsg = ""; let errorCodeMsg = "";  //hardwareError and errorCode for twilio.
        if (hardwareError) {
            var missingHardware = [];
            if (!this.state.hasAudioIn) {
                missingHardware.push("a microphone");
            }

            if (!this.state.hasAudioOut) {
                missingHardware.push("speakers");
            }

            if (!this.state.hasVideoIn) {
                missingHardware.push("a video camera");
            }

            var hardwareString = missingHardware.join(", ");
            var lastComma = hardwareString.lastIndexOf(",");
            if (lastComma > 0) {
                hardwareString = hardwareString.substring(0, lastComma) + " and " + hardwareString.substring(lastComma + 1, hardwareString.length);
            }
            hardwareErrorMsg = "We're not able to load your video visit. Please make sure you have " + hardwareString + " connected and enabled on your computer.";
        }

        if (errorCode && (errorCode === 222 || errorCode === 111)) {
            if (isSDC) {
                errorCodeMsg = (<span>{errorCode === 222 ? "Your appointment has ended. Please schedule a new appointment." : "We’re sorry, we are not able to load your video visit."}</span>);
            } else {
                //const { videoVisits } = this.props;
                errorCodeMsg = (<span>{errorCode === 222 ? "Your appointment has ended. Please schedule a new appointment or contact your doctor at" : "We’re sorry, we are not able to load your video visit. Please contact your doctor at"} <a href={"tel:" + _appointmentDetails.phone}>{_appointmentDetails.phone}</a> for assistance.</span>);
            }
        } else if (timeToStartVideo !== null && !timeToStartVideo) {
            errorMsg = "It is not time for the video visit. Please launch the video visit closer to your appointment time.";
        }
        else if (errorCode && (errorCode === 222 || errorCode === 111)) {
            errorMsg = errorCodeMsg;
        }
        else if (hardwareError) {
            errorMsg = hardwareErrorMsg;
        } else if (this.state.isCurrentSystemRestricted) {
            errorMsg = "You're not authorized to join the room.";
        }
        else if (videoDetailsError) {
            errorMsg = "We're sorry, we're not able to load your video visit. Please try again.";
        }

        return errorMsg;
    }

    validateCurrentVisitIsSDC(appDetails) {
        const { visitTypeForSDC } = this.props;
        let isSDCVisit = false;
        if (appDetails && appDetails.visitTypeIDs) {
            const currentVisitTypeId = Tools.findInternalId(appDetails.visitTypeIDs);
            isSDCVisit = currentVisitTypeId && currentVisitTypeId === visitTypeForSDC ? true : false;
        }
        return isSDCVisit;
    }

    onUserSwitched = (userSelected, index) => {
        window.userToSwitch = userSelected;
    }

    tryAgainClick() {
        this.setState({ videoVisitError: false }, () => {
            if (this.state.isTestVideo) {
                this.testVideoVisit();
            }
        });
    }

    onTwilioRoomError = (error) => {
        const { message, code, name } = error || {};
        if (endCall) {
            endCall();
        }

        let errorCode = '';
        const mediaErrors = [
            'NotAllowedError',
            'NotFoundError',
            'NotReadableError',
            'OverconstrainedError'
        ];

        if (name && mediaErrors.indexOf(name) > -1) {
            errorCode = name;
        } else if (code) {
            errorCode = code;
        }

        const currentBrowserIsMobile = Tools.isMobile();

        const roomError = enhanceMessage(message, errorCode, currentBrowserIsMobile, CONSUMER);
        if (roomError)
            this.setState({ roomError, showTwilioRoomTryAgain: code && [53000, 53204, 53001, 53405].indexOf(code) > -1 ? true : false });

    }

    onPreflightComplete = () => {
        this.setState({ preflightComplete: true }, () => {
            const { roomConnectionData, rtcDiagnosticsComplete, roomTokenAssigned } = this.state;
            const { token = "", roomName = "", twilioUserName = "", twilioConnectSettings = {}, twilioDiagnosticsSettings = {} } = roomConnectionData || {};
            if (rtcDiagnosticsComplete && !roomTokenAssigned && token && roomName) {  // restoring room state once  preflight and rtcDiagnostics both done either with success or failure.
                this.setState({
                    twilioToken: token,
                    twilioRoomName: roomName,
                    twilioUserName: twilioUserName,
                    twilioConnectSettings: twilioConnectSettings,
                    twilioDiagnosticsSettings: twilioDiagnosticsSettings,
                    showPreflight: false,
                    isFetchingTwilioToken: false,
                    isFetchingSharedLinkToken: false,
                    roomTokenAssigned: true
                });
            }
            else
                this.setState({ showPreflight: false });
        });

    }

    onRTCDiagnosticsComplete = () => {
        this.setState({ rtcDiagnosticsComplete: true }, () => {
            const { roomConnectionData, preflightComplete, roomTokenAssigned } = this.state;
            const { token = "", roomName = "", twilioUserName = "", twilioConnectSettings = {}, twilioDiagnosticsSettings = {} } = roomConnectionData || {};
            if (preflightComplete && !roomTokenAssigned && token && roomName) { // restoring room state once  preflight and rtcDiagnostics both done either with success or failure.
                this.setState({
                    twilioToken: token,
                    twilioRoomName: roomName,
                    twilioUserName: twilioUserName,
                    twilioConnectSettings: twilioConnectSettings,
                    twilioDiagnosticsSettings: twilioDiagnosticsSettings,
                    showPreflight: false,
                    isFetchingTwilioToken: false,
                    isFetchingSharedLinkToken: false,
                    roomTokenAssigned: true
                });
            }

        });
    }

    render() {
        const {
            videoVisitError,
            showAmbulatorySurvey,
            isTestVideo,
            timeToStartVideo,
            errorCode,
            errorMsg,
            isFetchingTwilioToken,
            isFetchingSharedLinkToken,
            twilioToken,
            twilioRoomName,
            isPermissionToDevices,
            mediaError,
            twilioUserName,
            roomError,
            twilioConnectSettings,
            showSharedLinkTryAgain,
            showTwilioRoomTryAgain,
            twilioDiagnosticsSettings,
            isConnecting,
            showPreflight,
            preflightTokenInfo,
            showApprovalDenied,
            showApprovalWaiting,
            showUserKicked
        } = this.state;

        const { isFromNonLogin, currentUser, hasMyChart, dashboardData, needIOSUpgrade, roomId, jwttoken, sharedLinkCode, resetJoinVisit } = this.props;
        const patientInternalId = _patientInternalId || (currentUser && currentUser.internalId) || "";
        const appointments = dashboardData && dashboardData.data && dashboardData.data.appointments;

        if (!isFromNonLogin && patientInternalId) {
            if (hasMyChart && appointments) {
                let tempAppointments = appointments.find(visit => visit.csnIdOfAppointment === _csnId);
                _appointmentDetails = tempAppointments && tempAppointments.patientInternalId &&
                    tempAppointments.patientInternalId.trim() === patientInternalId ? tempAppointments : null;
            }
            const { eCheckInStatus } = _appointmentDetails || {};
            if (!isTestVideo && (!_csnId || !hasMyChart || !patientInternalId || (dashboardData && !dashboardData.isWaiting && !appointments) ||
                (appointments && (!eCheckInStatus || eCheckInStatus.toLowerCase() !== "completed")))) {
                this.props.history.push('/');
                return (<Dashboard />);
            }
        }

        var isPOC = this.props.roles ? this.props.roles.toLowerCase().indexOf("video_poc") >= 0 : false;

        this.isSDCVisit = this.validateCurrentVisitIsSDC(_appointmentDetails);
        let waitingRoomMsg = "Hang tight! We will be with you shortly. Thank you for your patience.";
        if (_appointmentDetails && _appointmentDetails.physicianName && !this.isSDCVisit) {
            waitingRoomMsg = `Welcome! ${formatDoctorName(_appointmentDetails.physicianName)} will be with you shortly.`
        }

        const hasHardwareMissing = !this.state.hasAudioIn || !this.state.hasAudioOut || !this.state.hasVideoIn;
        const hardwareError = false; //(this.state.hardwareScanned === true && hasHardwareMissing === true);

        const videoDetailsError = !(_csnId && (!patientInternalId || !appointments || _appointmentDetails) || isTestVideo) && !((roomId && jwttoken) || sharedLinkCode);
        if (this.state.enableLaunchButton && _csnId && /*!hasHardwareMissing &&*/ !isTestVideo && this.hasVideoVisitLanched === false) {
            this.startVideoVisit();
        }

        this.isFromSharedLink = isFromNonLogin;
        this.videoErrorMsg = this.getVideoErrorMsg(videoDetailsError, hardwareError, timeToStartVideo, errorCode, this.isSDCVisit);
        let confirmationMsg = 'Are you sure you want to leave this page and stop the video visit?';
        let confirmationActionText1 = 'Stay on this page';
        let confirmationActionText2 = 'Leave this page';
        let userSwitchMsg = 'and stop the video visit';
        const roomStateConnected = window.twilioRoom && window.twilioRoom.state && window.twilioRoom.state === "connected" ? true : false;

        return (
            <div className="ambulatory-care-container" id="ambulatory-care-container">
                {showPreflight && preflightTokenInfo && <Preflight preflightTokenInfo={preflightTokenInfo} callbackOnComplete={this.onPreflightComplete} />}
                {!videoVisitError ? this.isSupportedBrowser && (this.videoErrorMsg === "" && !roomError) ?
                    <React.Fragment>
                        {!isFromNonLogin && !roomStateConnected && (!dashboardData || dashboardData.isWaiting)
                            ? <Spinner />
                            : (showApprovalDenied || showApprovalWaiting || showUserKicked ?
                                <GuestVideoVisitStatus status={showApprovalDenied ? TOKEN_STATUS.DENIED : showApprovalWaiting ? TOKEN_STATUS.WAITING : showUserKicked ? TOKEN_STATUS.KICKED : ""} userName={twilioUserName && twilioUserName.split("||") && twilioUserName.split("||").length >= 3 && twilioUserName.split("||")[3] || ""} /> :
                                !showAmbulatorySurvey ?
                                    <React.Fragment>
                                        <TwilioVideo
                                            isFromNonLogin={isFromNonLogin}
                                            twilioToken={isFromNonLogin ? jwttoken ? jwttoken : twilioToken : twilioToken}
                                            twilioRoomName={isFromNonLogin ? jwttoken ? roomId : twilioRoomName : twilioRoomName}
                                            isFetchingTwilioToken={isFromNonLogin && jwttoken ? false : (isFetchingTwilioToken || isFetchingSharedLinkToken)}
                                            source={CONSUMER}
                                            isSDCVisit={this.isSDCVisit}
                                            onTwilioEndCall={this.onTwilioEndCall}
                                            isPermissionToDevices={isPermissionToDevices}
                                            error={mediaError}
                                            twilioUserName={twilioUserName}
                                            onTwilioRoomError={this.onTwilioRoomError}
                                            twilioSettings={twilioConnectSettings ? { twilioConnectSettings, isDynamicSettings: true } : null}
                                            waitingRoomMsg={waitingRoomMsg}
                                            twilioDiagnosticsSettings={twilioDiagnosticsSettings}
                                        />

                                        <ConfirmationModal
                                            when={!this.twilioBeforeError && roomStateConnected}
                                            actionText1={confirmationActionText1}
                                            actionText2={confirmationActionText2}
                                            message={confirmationMsg}
                                            userSwitchMsg={userSwitchMsg}
                                            switchToMyChartUser={this.onUserSwitched}
                                            callbackOnLeave={this.callbackOnLeave}
                                            isSyncUserSwitch
                                        />
                                        <div className={isFromNonLogin ? "" : "container-fluid body-content video-visit-tooltip-container"}>
                                            <div className="row">
                                                <div className="col-12 maxWidth-content">
                                                    <VideoVisitToolTip />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                    : <AmbulatorySurvey csnId={_csnId} isSDCVisit={this.isSDCVisit} twilioUserName={twilioUserName} isFromNonLogin={isFromNonLogin} externalEventId={isFromNonLogin ? jwttoken ? roomId : twilioRoomName : null} />
                            )}
                    </React.Fragment>
                    : (this.isSupportedBrowser ?
                        <AmbulatoryCareRoomStatus
                            videoErrorMsg={this.videoErrorMsg}
                            isFromNonLogin={isFromNonLogin}
                            roomError={roomError}
                            onTryAgain={showSharedLinkTryAgain || showTwilioRoomTryAgain ? { showSharedLinkTryAgain: showSharedLinkTryAgain, showTwilioRoomTryAgain: showTwilioRoomTryAgain, pathName: this.props.location, history: this.props.history, onTryAgainClick: showTwilioRoomTryAgain ? () => { this.setState({ showTwilioRoomTryAgain: false, roomError: "" }); } : null } : null}
                            resetJoinVisit={resetJoinVisit}
                        />
                        : <BrowserErrorMessages isFromNonLogin={isFromNonLogin} needIOSUpgrade={needIOSUpgrade} />
                    )
                    : (isTestVideo && !isPOC) ? <NotAuthorized /> : <ErrorPage heading={errorMsg}>
                        <span>Please <Link to={{ pathname: _csnId ? `/videovisit/${_csnId}` : "/videovisit" }} onClick={this.tryAgainClick}>try again.</Link></span>
                    </ErrorPage>
                }
            </div>
        );
    }

}


const mapStateToProps = (state, ownProps) => {
    const currentUser = d.hydrateProxyUser(state.domain.cu);
    return {
        userName: state.domain.un,
        myChartUserId: state.domain.mc,
        email: state.domain.e,
        currentUser,
        hasMyChart: state.domain.hm,
        token: state.domain.t,
        roles: state.sso.userDetails ? state.sso.userDetails.Roles : "",
        dashboardData: state.dashboard && state.dashboard.bffDashboardData,
        serverData: state.session.serverData,
        videoVisitEnabledMinutesBeforeStart: state.session.serverData && state.session.serverData.videoVisitEnabledMinutesBeforeStart ? state.session.serverData.videoVisitEnabledMinutesBeforeStart : "30",
        videoVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.videoVisitEnabledMinutesAfterStart ? state.session.serverData.videoVisitEnabledMinutesAfterStart : "45",
        SDCVisitEnabledMinutesBeforeStart: state.session.serverData && state.session.serverData.SDCVisitEnabledMinutesBeforeStart ? state.session.serverData.SDCVisitEnabledMinutesBeforeStart : "5",
        SDCVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.SDCVisitEnabledMinutesAfterStart ? state.session.serverData.SDCVisitEnabledMinutesAfterStart : "10",
        visitTypeForSDC: state.session.serverData && state.session.serverData.visitTypeForSDC ? state.session.serverData.visitTypeForSDC : "60148",
        userIsSwitching: state.memberships.switchingProxyUser,
        ssoBaseUrl: state.session.serverData ? state.session.serverData.ssoBaseURL : "",
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AmbulatoryCareVideoVisit));
